// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2nby8","name":"Header_name__1toWX","birthday":"Header_birthday__dNb_4","skeleton":"Header_skeleton__1HDyD"};